module.exports = __webpack_public_path__ + "static/img/abH1.86d0e99a.png";